export default __webpack_public_path__ + "static/media/dabhoang.b97a6e90.jpg";